import BreadcrumbView from "../../common/breadcrumb/breadcrumb.html";
import PersonsGiftsListView from "./persons_gifts-list.html";
import PersonsGiftsEditView from "./persons_gifts-edit.html";


angular.module("persons_gifts", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('persons_gifts', {
                url: "/persons_gifts",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('persons_gifts.list', {
                url: "/list",
                controller: "PersonsGiftsListCtrl",
                template: PersonsGiftsListView,
                data: { pageTitle: 'Regalos' },
                requiredPermission: ["PERSONS_GIFTS_READ"]
            })            
            .state('persons_gifts.edit', {
                url: "/edit/:in_out/:id",
                controller: "PersonsGiftsEditCtrl",
                template: PersonsGiftsEditView,
                data: { pageTitle: 'Regalos' },
                requiredPermission: ["PERSONS_GIFTS_READ"]
            })
    }])
;